export const HOME_SERVICES_BADGE_URL = 'https://assets.homedepot-static.com/images/v1/home-services-icon.svg';
export const KITCHEN_CABINETS_IDENTIFIER = 'BRIO_INAISLE_SFI_CABINETS';